import type {
  HotelBookableOptionRoom,
  Image,
  Money,
} from '@libs/trip-planner-interfaces';

import type { HotelStayTag } from '../../stayTag';

export interface HotelRoomId {
  roomCode: string;
  boardBasis: string;
  roomTypeId?: number;
}

export interface StayId {
  hotelRoomIds: HotelRoomId[];
  isRefundable: boolean;
}

export interface HotelRoom extends HotelBookableOptionRoom {
  name: string;
  paxString: string;
  description: string;
}

export const enum StaySelectionType {
  ManuallySelected = 'manually-selected',
  None = 'none',
  Suggested = 'suggested',
}

export interface Stay {
  stayId: StayId;
  rooms: HotelRoom[];
  totalPriceMoney: Money;
  totalPrice: string;
  grossPrice?: string;
  numberOfNights: number;
  imagesURL: Image[];
  tag?: HotelStayTag;
  selectionType?: StaySelectionType;
}
